import { Component, OnInit } from '@angular/core';
import {CaseItem} from './jcal-case-item';
import {caseGroupEntities} from './jcal-case-entity'

@Component({
  selector: 'app-jcal',
  templateUrl: './jcal.component.html',
  styleUrls: ['./jcal.component.css']
})
export class JcalComponent implements OnInit {


  caseGroup = caseGroupEntities;
  selectCaseItem:CaseItem=caseGroupEntities[0];

  onSelect(caseItem:CaseItem): void {
    if(this.selectCaseItem && this.selectCaseItem.id == caseItem.id){
      this.selectCaseItem=null;      
    }else{ 
      this.selectCaseItem =  caseItem;       
    }
  }

  constructor() { }

  ngOnInit() {
  }

}
